import Layout from '@/layout';

export default {
  path: '/stat',
  component: Layout,
  meta: {
    title: '统计报表',
    icon: 'iconfont icon-tongji',
    code: '010204'
  },
  children: [
    // {
    //   path: '',
    //   name: 'DailyStat',
    //   component: () => import('@/views/statistics/daily/index.vue'),
    //   props: true,
    //   meta: {
    //     title: '监测统计',
    //     icon: 'iconfont icon-richangjiancha',
    //     code: '01020401'
    //   }
    // },
    {
      path: 'alarm/:sn?',
      name: 'AlarmStat',
      component: () => import('@/views/statistics/alarm'),
      props: true,
      meta: {
        title: '报警统计',
        icon: 'iconfont icon-00-baojingjilu-05-05',
        code: '01020404'
      }
    },
    {
      path: 'detect/:sn?',
      name: 'DetectStat',
      component: () => import('@/views/statistics/detect'),
      props: true,
      meta: {
        title: '检测统计',
        icon: 'iconfont icon-iconfontzhizuobiaozhun12',
        code: '01020403'
      }
    },
    {
      path: 'states/:sn?',
      name: 'StateStat',
      component: () => import('@/views/statistics/state'),
      props: true,
      meta: {
        title: '设备状态',
        icon: 'iconfont icon-shebeizhuangtai',
        code: '01020405'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
